import { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
import TableRow from "./TableRow";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { isMobileApp, isWebApp } from "../store/api/CommonFunctions";
import Loader from "react-loader-spinner";
import { CaretLeftFill, CaretRightFill, SkipBackwardFill, SkipForwardFill } from "react-bootstrap-icons";
/**
 * apiUrl When You Want Fetch Data With Url Directly From Server,
 * apiMethod: Get/POST,
 * getData: For When You Have Method For Getting Data And Updating State,
 * reducerName: Name Of Reducer Affected By Your Method,
 * objectName: Object Have Been Filled By Dispatcher,
 * filterData Is An JSON Object,
 **/
/**
 * @component
 * @param {object} props 
 * @param {[{colName:string, colTitle:string, colType:'boolean' | 'currency' | 'string' | 'number' |'color' |'calc' |'img', showInMobile:boolean}]} props.columns
 * @param {function} props.searchMethod
 * @param {object} props.filterData
 * @param {[{title:string, type:string, tooltip:string, className:string, onClick:function, icon:JSX.Element}]} props.rowButtons
 * @param {string} props.reducerName -برای وقتی که دیتاسورس state است
 * @param {string} props.objectName -نام آبجکتی از reducer که دیتا را در خود دارد
 * @param {function} props.rowClick
 * @param {function} props.rowDoubleClick
 * @param {object} props.dataList -برای وقتی که دیتاسورس یک فهرست مستقیم از داده است
 * @param {boolean} props.hasPaging
 * @param {ref} props.tableRef
 * @param {boolean} props.forceRowClickInMobile -برای اینکه مجبور کنیم توی حالت موبایل علاوه بر باز کردن ردیف عملیاتی را هم انجام دهد
 * @param {object} props.style
 * @param {string} props.className
 * @param {boolean} props.searchable -اگر برابر با true باشد کادر جستجو در اولین ردیف جدول نمایش داده می شود
 * @param {int} props.maxHeight 
 * @returns JSX.Element
 */
export default function BihamtaTable(props) {
    const { columns, searchMethod, filterData, rowButtons, reducerName, objectName, rowClick, rowDoubleClick, dataList, hasPaging, tableRef, 
            forceRowClickInMobile, style, className, searchable, maxHeight } = props;

    const rowNumber = columns.find(c => c.colName?.toLowerCase() === "rownumber");
    const searchColSpan = columns.filter(c => c.showCondition === undefined || c.showCondition() === true).length;
    const altTableRef = useRef();
    const currPage = useRef(1);
    const totalPage = useRef(0);
    const resultList = useRef({});
    const [fetchedData, onGetData] = useState([]);
    const [searchError, setSearchError] = useState(null);
    const [selectAllChecked, setSelectAllCheck] = useState(false);
    const [tooltip, setTooltip] = useState(null);
    const list = useSelector(state => state && reducerName ? state[reducerName][objectName] : []);
    if (reducerName && objectName) {
        resultList.current = list;
    }
    else {
        resultList.current = fetchedData;
    }
    if (resultList.current)
        if (hasPaging && filterData && (filterData.Skip === 0 || totalPage.current < 1)) {
            const take = Number(filterData?.Take ?? 10);
            currPage.current = 1;
            const t = Number(resultList.current?.TotalCount ?? 0);
            totalPage.current = take > 0 ? Math.floor(t / take) + ((t % take) > 0 ? 1 : 0) : 0;
        }
    function changePage(inc) {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        if (filterData) {
            filterData.Skip = currPage.current - 1;
        }
        if (searchMethod) {
            if (!reducerName) {
                searchMethod(filterData, onGetData);
            }
            else {
                searchMethod(filterData);
            }
        }
    }
    function gotoFirstPage() {
        currPage.current = 1;
        if (filterData) {
            filterData.Skip = currPage.current - 1;
        }
        if (searchMethod) {
            if (!reducerName) {
                searchMethod(filterData, onGetData);
            }
            else {
                searchMethod(filterData);
            }
        }
    }
    function gotoLastPage() {
        currPage.current = totalPage.current;
        if (filterData) {
            filterData.Skip = currPage.current - 1;
        }
        if (searchMethod) {
            if (!reducerName) {
                searchMethod(filterData, onGetData);
            }
            else {
                searchMethod(filterData);
            }
        }
    }
    function tableClassName() {
        let cName = className ?? "";
        if (!className?.includes("mt-") && !maxHeight) {
            cName += " mt-2";
        }
        if (maxHeight) {
            cName += " fixedHeightTable mt-0 mb-0";
        }
        return cName;
    }
    function findInTable(e) {
        const table = tableRef?.current ?? altTableRef.current;
        const text = e.target.value.toLowerCase();
        for (let i = 1; i < table.rows.length; i++) {
            const r = table.rows[i];
            if (r.id === "tableRowSearch" || text === "" || r.innerText.toLowerCase().includes(text)) {
                r.style.display = "table-row";
            }
            else {
                r.style.display = "none";
            }

        }
    }
    function handleSelectAll(e, fn) {
        setSelectAllCheck(e.target.checked);
        fn?.(e);
    }
    useEffect(() => {
        const colName = columns.find(c=>c.selectAll)?.colName;
        if(colName && dataList?.Data)
        {
        if(dataList.Data.some(d=>!JSON.parse(d[colName])))
        {
            setSelectAllCheck(false);
        }
        else if(!selectAllChecked)
        {
            setSelectAllCheck(true);
        }
    }
        if (hasPaging || (!reducerName && dataList && !(filterData?.Skip))) {
            onGetData(dataList);
        }
        if (reducerName && filterData?.Skip && Number(currPage.current) - 1 !== Number(filterData.Skip)) {
            currPage.current = filterData.Skip + 1;
            searchMethod(filterData);
        }
    }, [dataList])
    useEffect(() => {
        if (Number(maxHeight) > 0) {
            const table = tableRef?.current ?? altTableRef.current;
            const wrapper = table?.closest('.table-responsive');
            if (wrapper) {
                wrapper.style.setProperty('--tableMaxHeight', `${maxHeight}px`);
            }
        }
    }, [maxHeight]);
    return (
        <Fragment>
            {tooltip && (
                <div className="table-tooltip"
                    style={{
                        top: tooltip.y ,
                        left: tooltip.x,
                        "--maxWidth": tooltip.width
                    }}
                >
                   <span style={{ flex: 1 }}>{tooltip.text}</span>
                </div>)}

            <Table className={tableClassName()} responsive={true} ref={tableRef ?? altTableRef} style={style} /*datasource={resultList.current?.Data}*/>
                <thead>
                    <tr>
                        {rowNumber &&
                            <th title={resultList.current?.TotalCount ?? 0} style={{
                                position: maxHeight ? "sticky" : "unset", top: 0, backgroundColor: "#b6b6b6", zIndex: 50,
                                borderBottomColor: (resultList?.current?.Data?.length > 0 && !searchable ? "#dfdcdc" : "unset")
                            }}>
                                {rowNumber.colTitle}
                            </th>}
                        {columns && columns.filter(c => c.colName?.toLowerCase() !== "rownumber").map((c, i) =>
                            (c.showCondition === undefined || c.showCondition() === true) &&
                            (isWebApp() || (isMobileApp() && c.showInMobile)) &&
                            <th key={i} style={{ position: maxHeight ? "sticky" : "unset", top: 0, backgroundColor: "#b6b6b6", zIndex: 50, ...c.headerStyle }}>
                                {c.selectAll && c.colType === "boolean" && Array.isArray(resultList.current?.Data) && resultList.current.Data.length > 0 &&
                                    <Fragment>
                                        <input type="checkbox" className="form-check-input" checked={selectAllChecked} onChange={(e) => handleSelectAll(e, c.selectAll)} style={{ marginTop: "1px", borderColor: "#858181" }} />&nbsp;
                                    </Fragment>
                                }
                                {c.colTitle}
                            </th>
                        )}
                        {isWebApp() && rowButtons?.length > 0 && <th style={{ position: maxHeight ? "sticky" : "unset", top: 0, backgroundColor: "#b6b6b6", zIndex: 50 }}>&nbsp;</th>}
                    </tr>
                </thead>
                <tbody>
                    {resultList.current === "PENDING" &&
                        <tr>
                            <td colSpan={columns.length + (rowNumber ? 1 : 0) + (rowButtons?.length > 0 ? 1 : 0)} style={{ textAlign: "center" }}>
                                <Loader type="BallTriangle" color="#bb1370" height={30} />
                            </td>
                        </tr>}
                    {resultList.current?.Error &&
                        <tr>
                            <td colSpan={searchColSpan + (rowButtons?.length > 0 ? 1 : 0)} style={{ textAlign: "center", color: "red" }}>
                                {resultList.current.Error}
                            </td>
                        </tr>
                    }
                    {Array.isArray(resultList.current?.Data) &&
                        <Fragment>
                            {isWebApp() && searchable && resultList.current.Data.length > 0 &&
                                <tr id="tableRowSearch" style={{ position: "sticky", top: 32, backgroundColor: "#F9EFEF", zIndex: 1 }}>
                                    <td colSpan={searchColSpan + (rowButtons?.length > 0 ? 1 : 0)} style={{ padding: 3 }}>
                                        <input className="tableRowInput" onChange={findInTable} placeholder="جستجو کنید" style={{ width: "200px" }} />
                                    </td>
                                </tr>
                            }
                            {resultList.current.Data.map((item, i) =>
                                <TableRow key={i} row={item} buttons={rowButtons} indx={(filterData?.Skip ?? 0) * (filterData?.Take ?? 0) + i}
                                    cols={columns} onclick={rowClick} onDoubleClick={rowDoubleClick} forceRowClickInMobile={forceRowClickInMobile} onShowTooltip={setTooltip} />)}
                        </Fragment>
                    }
                </tbody>
            </Table>
            {totalPage.current > 0 && hasPaging &&
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-block" style={{ padding: "2px", marginRight: "2px" }} title='صفحه نخست' disabled={currPage.current === 1} onClick={gotoFirstPage}><SkipForwardFill size={25} /></button>
                    <button className="btn btn-block" style={{ padding: "2px", marginRight: "2px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                    <span>{currPage.current + " از " + totalPage.current}</span>{resultList.current?.TotalCount && <span style={{ color: "gray" }}>&nbsp;{`(${resultList.current.TotalCount})`}</span>}
                    <button className="btn btn-block" style={{ padding: "2px", marginLeft: "2px" }} title='صفحه بعد' disabled={currPage.current === totalPage.current} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                    <button className="btn btn-block" style={{ padding: "2px", marginLeft: "2px" }} title='آخرین صفحه' disabled={currPage.current === totalPage.current} onClick={gotoLastPage}><SkipBackwardFill size={25} /></button>
                </div>
            }
        </Fragment>
    )
}